/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {startWebAuthnAuthentication} from '../api'

export const useMutationStartWebAuthnAuthentication = createReactQueryMutationHook('startWebAuthnAuthentication', startWebAuthnAuthentication)
